module.exports = __webpack_public_path__ + "img/06.e6ac339c.png";